import { render, staticRenderFns } from "./directInvest.vue?vue&type=template&id=8992dcfc&scoped=true"
import script from "./directInvest.vue?vue&type=script&lang=js"
export * from "./directInvest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8992dcfc",
  null
  
)

export default component.exports